import { z } from "zod";

export const FinancialDocumentDetailIncludeSchema = z.object({
    includeAll: z.boolean().optional().default(true),
    includeAccountInfoExtraction: z.boolean().optional().default(false),
    includeBalanceSheetExtraction: z.boolean().optional().default(false),
    includeCoaExtraction: z.boolean().optional().default(false),
    includeGlExtraction: z.boolean().optional().default(false),
    includeAccrualExtractions: z.boolean().optional().default(false),
    includeLinkedItems: z.boolean().optional().default(false),
    includeTransactionMatches: z.boolean().optional().default(false),
});

export type FinancialDocumentDetailIncludeQuery = z.input<
    typeof FinancialDocumentDetailIncludeSchema
>;

export interface ResolvedFinancialDocumentDetailIncludes {
    includeAccountInfoExtraction: boolean;
    includeBalanceSheetExtraction: boolean;
    includeCoaExtraction: boolean;
    includeGlExtraction: boolean;
    includeAccrualExtractions: boolean;
    includeLinkedItems: boolean;
    includeTransactionMatches: boolean;
}

export const ALL_DETAIL_INCLUDES = Object.freeze({
    includeAccountInfoExtraction: true,
    includeBalanceSheetExtraction: true,
    includeCoaExtraction: true,
    includeGlExtraction: true,
    includeAccrualExtractions: true,
    includeLinkedItems: true,
    includeTransactionMatches: true,
} satisfies ResolvedFinancialDocumentDetailIncludes);

export function resolveFinancialDocumentDetailIncludes(
    query: FinancialDocumentDetailIncludeQuery,
): ResolvedFinancialDocumentDetailIncludes {
    if (query.includeAll !== false) {
        return ALL_DETAIL_INCLUDES;
    }

    return {
        includeAccountInfoExtraction:
            query.includeAccountInfoExtraction ?? false,
        includeBalanceSheetExtraction:
            query.includeBalanceSheetExtraction ?? false,
        includeCoaExtraction: query.includeCoaExtraction ?? false,
        includeGlExtraction: query.includeGlExtraction ?? false,
        includeAccrualExtractions: query.includeAccrualExtractions ?? false,
        includeLinkedItems: query.includeLinkedItems ?? false,
        includeTransactionMatches: query.includeTransactionMatches ?? false,
    };
}
